import { Slide } from "react-reveal";
import desktop from "../../../assets/images/case-studies/cases/hanasafaris/hanasafaris-desktop.jpg";
import tablet from "../../../assets/images/case-studies/cases/hanasafaris/hanasafaris-tablet.jpg";
import phone from "../../../assets/images/case-studies/cases/hanasafaris/hanasafaris-mobile.jpg";
import logo from "../../../assets/images/case-studies/cases/hanasafaris/hanasafaris-logo.png";
import KCGCaseStudyCard from "../case-study-cards/KCGCaseStudyCard";
import FlexipaintersCaseStudyCard from "../case-study-cards/FlexipaintersCaseStudyCard";
import SdaCaseStudyCard from "../case-study-cards/SdaCaseStudyCard";
import SolutionsNtunaCTAWorld from "../../solutions/SolutionsNtunaCTAWorld";

const HanaSafarisCaseStudyBody = () => {
  return (
    <section>
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <ul className="case-study-body-items">
              <li className="case-study-item width-600 margin-auto section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    Project Summary
                  </h3>
                </Slide>
                <div className="summary-container">
                  <div className="summary-item">
                    <p className="summary-name">Client</p>
                    <p className="summary-answer">Hana Safaris</p>
                  </div>
                  <div className="summary-item">
                    <p className="summary-name">Industry</p>
                    <p className="summary-answer">
                      Tourism, Travel & Wildlife Safaris
                    </p>
                  </div>
                  <div className="summary-item">
                    <p className="summary-name">Services</p>
                    <p className="summary-answer">
                      Brand Identity Design, Website design, Logo design,
                      professional social media accounts resetup, search engine
                      optimization
                    </p>
                  </div>
                  <div className="summary-item">
                    <p className="summary-name">Location</p>
                    <p className="summary-answer">Entebbe, Kampala, Uganda</p>
                  </div>
                  <div className="summary-item">
                    <p className="summary-name">Timeline</p>
                    <p className="summary-answer">4 Weeks</p>
                  </div>
                  <div className="summary-item">
                    <p className="summary-name">Website</p>
                    <p className="summary-answer">
                      <a
                        href="https://hanasafaris.com"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        www.HanaSafaris.com
                      </a>
                    </p>
                  </div>
                </div>
              </li>
              <li className="case-study-item width-600 margin-auto section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    Project Overview
                  </h3>
                </Slide>
                <div className="case-study-item-text font-inter-regular">
                  <p>
                    <a
                      href="http://hanasafaris.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Hana Safaris
                    </a>
                    , is the world's first safari company dedicated exclusively
                    to Uganda's Five Giants™—the African Bush Elephant , White
                    Rhinoceros, the Hippopotamus, Rothschild's Giraffe, and Cape
                    Buffalo.
                  </p>
                  <p>
                    Hana Safaris set out to establish a distinctive position in
                    Uganda's wildlife tourism industry with a concept centered
                    exclusively on five of the country's most iconic wild
                    animals.
                  </p>
                  <p>
                    Rather than follow conventional tour, travel and safari
                    branding, the company wanted a brand that would celebrate
                    Uganda's natural heritage and offer international travellers
                    a different way to experience the country's wildlife.
                  </p>
                  <p>
                    We partnered with Hana Safaris to build a professional
                    digital presence around its unique vision: introducing the
                    world to Uganda's Five Giants™ through a safari experience
                    with a distinctive identity, compelling storytelling, and a
                    dedicated online platform. Thus, we worked on the brand
                    redesign, logo design, website design and development, and
                    SEO to translate that vision into a cohesive digital
                    experience.
                  </p>
                  <p>
                    The result is a dedicated safari website that introduces the
                    brand, tells the story behind Uganda's Five Giants™,
                    showcases individual expeditions, and guides prospective
                    travellers toward booking enquiries.
                  </p>
                </div>
              </li>
              <li className="case-study-item width-800 margin-auto section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    The Challenge
                  </h3>
                </Slide>
                <div className="case-study-item-text font-inter-regular">
                  <p className="italic">
                    <strong>
                      Building a Ugandan safari brand around a distinctive
                      wildlife concept.
                    </strong>
                  </p>
                  <p>
                    Hana Safaris needed more than an attractive and fast
                    website. It needed a digital identity capable of
                    communicating a distinctive safari concept to an
                    international audience, building confidence in the brand,
                    and presenting its experiences in a compelling, faster and
                    professional way.
                  </p>
                  <ul className="case-challenge-list padding-16">
                    <li>
                      <h4>Establishing a distinctive brand identity</h4>
                      <p>
                        Hana Safaris needed a professional visual identity that
                        reflected the ambition of the business and distinguished
                        it from conventional safari operators. The branding had
                        to feel cohesive, memorable, and appropriate for a
                        company targeting travellers interested in exceptional
                        wildlife experiences.
                      </p>
                    </li>
                    <li>
                      <h4>
                        Translating a unique concept into a compelling website
                      </h4>
                      <p>
                        The Uganda's Five Giants™ concept needed to be explained
                        clearly to visitors who might be unfamiliar with it. The
                        website had to communicate the brand story, introduce
                        the five animals, and help travellers understand what
                        makes Hana Safaris different.
                      </p>
                    </li>
                    <li>
                      <h4>Presenting safari experiences professionally</h4>
                      <p>
                        Individual expeditions needed to be organized in a way
                        that made destinations, durations, wildlife encounters,
                        and itinerary options easy to explore. A well-structured
                        presentation was essential to help prospective customers
                        move from curiosity to a serious booking enquiry.
                      </p>
                    </li>
                    <li>
                      <h4>Building discoverability through search</h4>
                      <p>
                        A beautiful website alone would not be enough. Hana
                        Safaris also needed an SEO foundation that could help
                        search engines understand its brand, pages,
                        destinations, and safari offerings while supporting its
                        long-term organic visibility.
                      </p>
                    </li>
                    <li>
                      <h4>Slow Website Performance</h4>
                      <p>
                        In today’s digital era, speed is critical to user
                        experience and business success. A slow-loading website
                        can frustrate visitors, drive potential customers away,
                        reduce engagement, and cause businesses to lose valuable
                        enquiries and sales. For a safari company targeting
                        international travellers, every second matters.
                      </p>
                      <p>
                        Hana Safaris needed a fast, responsive digital
                        experience that allows visitors to explore its unique
                        safari offerings smoothly, access information without
                        unnecessary delays, and move confidently towards making
                        an enquiry or booking.
                      </p>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="case-study-item width-600 margin-auto section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    The Solution
                  </h3>
                </Slide>
                <div className="case-study-item-text font-inter-regular">
                  <p>
                    NTUNA.COM delivered an integrated brand and digital
                    development project, bringing together visual identity,
                    storytelling, website engineering, and SEO.
                  </p>

                  <ul className="case-challenge-list padding-16">
                    <li>
                      <h4>
                        <span className="ntuna-coral">✔︎ </span> Brand Strategy,
                        Concept Development & Identity Design
                      </h4>
                      <p>
                        NTUNA.COM developed the distinctive brand concept that
                        positions Hana Safaris as the first safari company in
                        the world dedicated exclusively to Uganda’s Five
                        Giants™: the African Bush Elephant, White Rhinoceros,
                        Hippopotamus, Rothschild’s Giraffe, and Cape Buffalo.
                      </p>
                      <p>
                        Rather than presenting Hana Safaris as just another
                        safari operator, we established a focused identity built
                        around Uganda’s most iconic giant wildlife, giving the
                        brand a clear point of differentiation in the tourism
                        market.
                      </p>
                    </li>
                    <li>
                      <h4>
                        <span className="ntuna-coral">✔︎ </span> World-Class Logo
                        Redesign
                      </h4>
                      <p>
                        We translated the Uganda's Five Giants concept into a
                        distinctive brand identity, including the design of a
                        world-class logo and a comprehensive brand redesign.
                      </p>
                      <div className="case-study-images-container section-spacing-24">
                        <figure>
                          <img src={logo} alt="Hana Safaris new logo" />
                          <figcaption>Hana Safaris new logo</figcaption>
                        </figure>
                      </div>
                      <p>
                        The work focused on establishing a cohesive identity
                        that could communicate professionalism, wildlife
                        heritage, and a distinctive Ugandan safari experience.
                      </p>
                      <p>
                        This included aligning the brand presentation with the
                        central idea of Uganda's Five Giants™ and ensuring the
                        digital experience communicated that positioning
                        consistently.
                      </p>
                      <p className="boldTitle ntuna-dark section-spacing-30 no-padding-bottom">
                        Outcome
                      </p>
                      <p>
                        The result was a compelling brand foundation that
                        communicates Hana Safaris’ unique purpose, celebrates
                        Uganda’s extraordinary wildlife, and gives the company a
                        memorable identity to present to travellers around the
                        world.
                      </p>
                    </li>
                    <li>
                      <h4>
                        <span className="ntuna-coral">✔︎ </span> World-Class,
                        High-performance Website Design & Development
                      </h4>
                      <p>
                        We designed and built the Hana Safaris website at{" "}
                        <a
                          href="http://hanasafaris.com"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          HanaSafaris.com
                        </a>
                        , creating a dedicated digital platform for its brand
                        story and safari offerings.
                      </p>
                      <Slide top>
                        <div className="case-study-images-container section-spacing-24">
                          <figure>
                            <img
                              src={tablet}
                              alt="Hana Safaris website tablet view"
                            />
                            <figcaption>
                              Hana Safaris website tablet view
                            </figcaption>
                          </figure>
                          <figure>
                            <img
                              src={phone}
                              alt="Hana Safaris website mobile phone view"
                            />
                            <figcaption>
                              Hana Safaris website mobile phone view
                            </figcaption>
                          </figure>
                          <figure className="case-big-img">
                            <img
                              src={desktop}
                              alt="Hana Safaris website desktop view"
                            />
                            <figcaption>
                              Hana Safaris website desktop view
                            </figcaption>
                          </figure>
                        </div>
                      </Slide>
                      <p>
                        The website brings together several important elements:
                      </p>
                      <p>
                        <strong>Brand-led homepage: </strong> Introduces Hana
                        Safaris and communicates the Five Giants™ proposition.
                      </p>
                      <p>
                        <strong>Wildlife storytelling:</strong> Presents the
                        African Bush Elephant, White Rhinoceros, Hippopotamus,
                        Rothschild's Giraffe, and Cape Buffalo as the central
                        elements of the brand.
                      </p>
                      <p>
                        <strong>Expedition listings:</strong> Organizes safari
                        experiences into individual expedition offerings and a
                        journey featuring all five giants.
                      </p>
                      <p>
                        <strong>Booking journey:</strong> Provides clear calls
                        to action for booking enquiries and connecting with the
                        safari team.
                      </p>
                      <p>
                        <strong>Frequently asked questions:</strong> Addresses
                        practical concerns about itineraries, inclusions,
                        safety, travel preparation, and booking.
                      </p>
                      <p>
                        <strong>Responsive experience:</strong> Presents the
                        website for visitors browsing on different screen sizes.
                      </p>
                      <p>
                        <strong>Performance-conscious development:</strong>{" "}
                        Establishes a modern web foundation focused on usability
                        and efficient delivery.
                      </p>
                      <p>
                        <strong>Expedition details:</strong> Helps visitors
                        explore safari durations, destinations, experiences, and
                        available itinerary options.
                      </p>
                      <p>These features are visible on the live website.</p>
                      <p className="boldTitle ntuna-dark section-spacing-30 no-padding-bottom">
                        Outcome
                      </p>
                      <p>
                        Hana Safaris now has a dedicated digital platform that
                        communicates its identity, presents its offerings, and
                        gives prospective travellers a structured path to
                        enquire about an expedition.
                      </p>
                    </li>
                    <li>
                      <h4>
                        <span className="ntuna-coral">✔︎ </span>Search Engine
                        Optimization (SEO)
                      </h4>
                      <p>
                        We worked on SEO to establish a stronger foundation for
                        search engine understanding and organic discoverability.
                      </p>
                      <p>
                        The SEO work forms part of the broader digital
                        foundation, helping align the website's structure and
                        content with the brand's safari offerings and the
                        information prospective travellers seek.
                      </p>
                      <p>
                        The objective is to support visibility for relevant
                        searches, improve the organization of the website's
                        content, and create a foundation for ongoing organic
                        growth.
                      </p>
                      <p>
                        This included: Keyword optimisation, Technical SEO,
                        Metadata optimisation, Internal linking, Search-friendly
                        page structure and Performance improvements
                      </p>
                      <p className="boldTitle ntuna-dark section-spacing-30 no-padding-bottom">
                        Outcome
                      </p>
                      <p>
                        A search-oriented website foundation designed to support
                        long-term discoverability and make Hana Safaris'
                        offerings easier for search engines to interpret.
                      </p>
                    </li>

                    <li>
                      <h4>
                        <span className="ntuna-coral">✔︎ </span>Team Training &
                        Handover
                      </h4>
                      <p>
                        Beyond implementation, we provided a hands-on training
                        to equip the Hana Safaris team with the knowledge,
                        confidence and strategies to manage their web system
                        effectively — ensuring long term independence and smooth
                        day-to-day operations.
                      </p>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="case-study-item width-600 margin-auto section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    Results & Impact
                  </h3>
                </Slide>
                <div className="case-study-item-text font-inter-regular">
                  <p>
                    The project delivered a more complete digital foundation for
                    Hana Safaris, combining brand identity and a functional
                    website into one cohesive customer experience.
                  </p>
                  <p>Key outcomes included:</p>
                  <ul className="inner-list">
                    <li>
                      <span>
                        A distinctive brand identity: a professionally designed
                        logo and refreshed brand presentation built around Hana
                        Safaris' unique wildlife positioning.
                      </span>
                    </li>
                    <li>
                      <span>
                        A dedicated digital home: a complete website that
                        introduces the company, explains its proposition, and
                        presents its safari experiences in one place.
                      </span>
                    </li>
                    <li>
                      <span>
                        Clearer differentiation: The Uganda's Five Giants™
                        concept is central to the website's storytelling, giving
                        visitors a clear understanding of what distinguishes the
                        brand.
                      </span>
                    </li>
                    <li>
                      <span>
                        A more structured customer journey: Visitors can
                        discover expeditions, explore practical information,
                        review frequently asked questions, and proceed to
                        booking enquiries.
                      </span>
                    </li>
                    <li>
                      <span>
                        A foundation for organic growth: SEO work provides a
                        starting point for improving search visibility as the
                        website develops and the business builds its online
                        presence.
                      </span>
                    </li>
                  </ul>
                </div>
              </li>

              <li className="case-study-item width-600 margin-auto section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    What the Client Said
                  </h3>
                </Slide>
                <div className="case-study-item-text font-inter-regular">
                  <blockquote>
                    <p>
                      "Working with NTUNA.COM helped us bring the Hana Safaris
                      vision to life. From our brand identity and logo to our
                      website and SEO, the team helped us create a professional
                      digital presence that reflects what makes Hana Safaris
                      unique. We now have a platform to tell our story, showcase
                      our expeditions, and connect with travellers interested in
                      experiencing Uganda's Five Giants™."
                    </p>
                    <p className="boldTitle right-align">
                      — Mr. Onega Robert, CEO & Co-Founder, Hana Safaris
                    </p>
                  </blockquote>
                </div>
              </li>
              <li className="case-study-item width-600 margin-auto section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    Have a Vision Worth Taking to the World?
                  </h3>
                </Slide>
                <div className="case-study-item-text font-inter-regular">
                  <p>
                    Your business deserves more than a website that simply
                    exists. It deserves a professional brand and digital
                    experience that communicates its value, earns customer
                    confidence, and supports its ambitions.
                  </p>
                  <p>
                    At NTUNA.COM, we combine strategic branding,
                    high-performance website development, and SEO to help
                    businesses build a stronger digital presence.
                  </p>
                  <p>Let's build yours.</p>
                </div>
              </li>
            </ul>
            <SolutionsNtunaCTAWorld />
            <ul>
              <li className="case-study-item section-spacing-50 no-padding-top">
                <Slide top>
                  <h3 className="case-study-body-section-title ntuna-text-fill">
                    Related Case Studies
                  </h3>
                </Slide>
                <ul className="case-studies-container">
                  <FlexipaintersCaseStudyCard />
                  <SdaCaseStudyCard />
                  <KCGCaseStudyCard />
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HanaSafarisCaseStudyBody;
